export default {
    app: {
        name: 'Forecaster',
        title: 'Forecaster',
        loading: 'Cargando...',
        error: 'Ha ocurrido un error.',
        saved: 'Guardado',
        save: 'Guardar',
    },
    home: {
        welcome: '¡Bienvenido a Forecaster!',
        upcomingRain: 'Lluvia futura',
        searchLocation: 'Buscar ubicación',
        loadingData: 'Cargando datos del tiempo...',
        findingLocation: 'Buscando tu ubicación...',
        geolocationError: 'No se pudo obtener la ubicación actual. Por favor, active los servicios de ubicación o busque una ubicación.',
        offlineError: 'Parece que no tienes conexión. Por favor, comprueba tu conexión a internet.',
        serverError: 'Hubo un problema al conectar con nuestro servidor. Por favor, inténtalo de nuevo más tarde.',
        forecastUnavailableError: 'No hay un pronóstico actualizado disponible para esta ubicación. Inténtalo de nuevo más tarde.',
        currentLocation: 'Ubicación actual',
        fetchError: 'Error al cargar los datos del tiempo. Por favor, inténtalo de nuevo más tarde.',
        retry: 'Reintentar',
        byMetNo: 'Proporcionado por YR.no',
        byMeteoFrance: 'Proporcionado por Météo-France',
        byAppleWeather: 'Proporcionado por {appleIcon} Weather',
        byGoogleWeather: 'Proporcionado por Google Weather',
        validUntil: 'Válido hasta las {time}',
        loadedAt: 'Actualizado a las {time}',
        currently: 'Actualmente',
        thisWeek: 'Esta semana',
        today: 'Hoy',
        tomorrow: 'Mañana',
        geolocationErrorGeneric: 'Algo salió mal al intentar detectar tu ubicación.',
        geolocationPermissionDenied: 'Se denegó el acceso a la ubicación. Por favor, permite compartir la ubicación en la configuración de tu navegador para continuar.',
        geolocationPositionUnavailable: 'No pudimos determinar tu ubicación. Esto puede deberse a una señal débil o a que los servicios de ubicación están desactivados.',
        geolocationTimeout: 'Está tardando demasiado en encontrar tu ubicación. Por favor, inténtalo de nuevo o comprueba tu conexión.',
        geolocationUnsupported: 'La ubicación no está disponible en este navegador o contexto. Usa HTTPS o busca una ubicación.',
        geolocationPromptRequired: 'Pulsa Reintentar para permitir el acceso a tu ubicación y continuar.',
        providerError: 'No se pudieron cargar los datos de {providerName}. Pueden estar experimentando problemas. Por favor, inténtalo de nuevo más tarde.'
    },
    units: {
        precipitation: {
            mm: '{value} mm',
            in: '{value} pulg',
        },
    },
    drawer: {
        currentLocation: 'Ubicación actual',
        starredLocations: 'Ubicaciones favoritas',
        starToSave: 'Marca un lugar como favorito para guardarlo aquí.',
        settings: 'Ajustes',
        colorGuide: 'Leyenda de colores',
        feedback: 'Enviar opiniones',
        helpTranslate: 'Ayuda a traducir',
    },
    colorGuide: {
        title: 'Leyenda de colores',
        clear: 'Despejado',
        clear_explanation: 'No se preveen lluvias y menos del 25% del cielo será cubiero por nubes.',
        partly_cloudy: 'Parcialmente nublado',
        partly_cloudy_explanation: 'Entre el 25% y el 75% del cielo estará cubierto. No se preveen lluvias.',
        cloudy: 'Nublado',
        cloudy_explanation: 'Más del 75% del cielo será nublado. No se preveen precipitaciones.',
        scattered_rain: 'Lluvia dispersa',
        scattered_rain_explanation: 'Lloverá en el área, pero no es seguro que caerá en la ubicación exacta.',
        rain: 'Lluvia',
        rain_explanation: 'Hay una gran posibilidad de lluvia.',
        scattered_snow: 'Nieve dispersa',
        scattered_snow_explanation: 'Nevará en el área, pero no es seguro que estará en la ubicación exacta.',
        snow: 'Nieve',
        snow_explanation: 'Hay una gran posibilidad de nieve.',
    },
    settings: {
        title: 'Ajustes',
        wind_speed_units_default: 'kmh',
        temperature_units_default: 'celsius',
        night_mode_default: 'system',
        units: 'Unidades',
        temperature_units: 'Temperatura',
        wind_speed_units: 'Velocidad del viento',
        precipitation_units: 'Precipitación',
        forecast: 'Predicción',
        hide_early_morning: 'Ocultar horas de la madrugada',
        hide_early_morning_explanation: 'Mostrar el tiempo desde las 5am en adelante en lugar de las 24 horas completas',
        appearance: 'Apariencia',
        theme: 'Tema',
        show_minMax: 'Mostrar temperaturas Mín/Máx',
        show_minMax_summary: 'Mostrar temperaturas mínimas/máximas diarias junto a la información de lluvia y nubes',
        auto_expand_today: 'Expandir automáticamente el pronóstico de hoy',
        about: 'Acerca de',
        privacy_policy: 'Política de privacidad',
        terms_of_service: 'Términos de servicio',
        provider: 'Proveedor',
        data_source: 'Fuente de datos',
        language: 'Idioma',
        unit_selection: {
            celsius: 'Celsius',
            fahrenheit: 'Fahrenheit',
        },
        wind_speed_unit_selection: {
            mph: 'mph',
            knots: 'nudos',
            kmh: 'km/h',
            ms: 'm/s',
            beaufort: 'Escala Beaufort',
        },
        precipitation_unit_selection: {
            mm: 'mm',
            inches: 'pulgadas',
        },
        night_mode_options: {
            system: 'Predeterminado del sistema',
            light: 'Claro',
            dark: 'Oscuro',
        },
        data_source_options: {
            auto: 'Automático',
            metno: 'YR.no',
            meteofrance: 'MeteoFrance',
            appleweather: 'Apple Weather',
            googleweather: 'Google Weather',
        },
        language_selection: {
            en: 'Inglés',
            de: 'Alemán',
            es: 'Español',
            fr: 'Francés',
            it: 'Italiano'
        },
    },
    provider_modal: {
        title: 'Elige tu fuente de datos meteorológicos',
        close_modal: 'Cerrar selección de proveedor',
        cancel: 'Cancelar',
        save: 'Guardar',
        metno_desc: 'Pronósticos globales de confianza del Instituto Meteorológico Noruego.',
        meteofrance_desc: 'Pronósticos detallados y de alta resolución para Francia.',
        appleweather_desc: 'Datos precisos y de alta resolución de Apple Weather.',
        googleweather_desc: 'Pronósticos globales de alta calidad de Google.',
        auto_desc: 'Deja que la aplicación elija automáticamente la mejor fuente para tu ubicación.',
    },
    searchModal: {
        searchForLocation: 'Buscar una ubicación...',
        placeholder: 'Buscar un lugar',
        closeModal: 'Cerrar modal de búsqueda',
        googleMapsError: 'Error al cargar la biblioteca de Google Maps Places:',
        googleMapsNotLoaded: 'La biblioteca de la API de JavaScript de Google Maps no se ha cargado.',
        placesLibraryError: 'La biblioteca de Places no se ha cargado completamente o falta el token de sesión.',
        fetchPredictionsError: 'Error al obtener las predicciones de lugares:',
        fetchDetailsError: 'Error al obtener los detalles del lugar:',
        noInput: 'Empieza a escribir para buscar ubicaciones.',
        noResults: 'No se encontraron resultados.',
        noRecentlyViewed: 'No hay ubicaciones vistas recientemente.',
        searchUnavailable: 'La búsqueda no está disponible porque los servicios de Google están bloqueados por este navegador o su configuración.',
        searching: 'Buscando...',
        recentlyViewed: 'Visto recientemente',
    },
    minutelyTimeline: {
        now: 'Ahora',
        minutes: '{minutes}',
        minutesWithUnit: '{minutes} min',
    },
    upcomingRain: {
        maxIntensity: 'Fuerte',
        midIntensity: 'Moderada',
        minIntensity: 'Ligera',
    },
    weeklyForecast: {
        rainCloud: 'Lluvia y nubes',
        temperature: 'Temperatura',
        wind: 'Viento',
    },
    feedback: {
        title: 'Tus comentarios son bienvenidos',
        message: 'Tus opiniones me ayudan a mejorar Forecaster. ¡Dime qué piensas!',
        featureIdeas: '¿Tienes una idea para una nueva función? Por favor, compártela.',
        contactUs: 'Puedes contactarme en',
        send: 'Enviar opiniones',
    },
    forecastInfo: {
        details: 'Información del pronóstico',
        explanation: 'Nuestros proveedores actualizan periódicamente los pronósticos del tiempo.',
        computed: 'Generado por el proveedor',
        expires: 'Se espera un nuevo pronóstico',
        loaded: 'Descargado',
        close: 'Cerrar',
    }
};
